module.exports = __webpack_public_path__ + "static/media/Manos2R.a81a1bb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Manos2R.png
// module id = 190
// module chunks = 0